import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { PIMExportApiResultModel } from "@tecumseh/Services/PIMExportService";
import { ContentModel, PIMAttributesApiResultModel } from "@tecumseh/Services/PIMGetAttributes";
import { Draft } from "immer";


const initialState: PIMExportApiResultModel = {
    isSuccess: false,
    message: "",
    loading: false
};

const reducer = {
    "Custom/PIMExport/StartExporting": (draft: Draft<PIMExportApiResultModel>, action: { exportResponse: PIMExportApiResultModel }) => {
        draft.loading = true;
        draft.isSuccess = false;
    },
    "Custom/PIMExport/ExportCompleted": (
    draft: Draft<PIMExportApiResultModel>, 
    action: { exportResponse: PIMExportApiResultModel }
    ) => {
        draft.isSuccess = action.exportResponse.isSuccess;
        draft.message = action.exportResponse.message;
        draft.loading = false;
    },
    "Custom/PIMExport/ExportFail": (
    draft: Draft<PIMExportApiResultModel>, 
    action: { exportResponse: PIMExportApiResultModel }
    ) => {
        draft.isSuccess = action.exportResponse.isSuccess;
        draft.message = action.exportResponse.message;
        draft.loading = false;
    }
    
};
export default createTypedReducerWithImmer(initialState, reducer);
